import { createActionGroup, emptyProps, props } from '@ngrx/store'

export const UiDesignerConfigPanelActions = createActionGroup({
  source: 'UI Designer Config Panel',
  events: {
    expressionGenerateClick: emptyProps(),
  },
})

export const UiDesignerExpressionModalActions = createActionGroup({
  source: 'UI Designer Expression Modal',
  events: {
    generateClick: emptyProps(),
    expressionUpdate: props<{ expression: string }>(),
    componentDestroy: emptyProps(),
  },
})

export const UiDesignerComputedModalActions = createActionGroup({
  source: 'UI Designer Computed Modal',
  events: {
    componentDestroy: emptyProps(),
  },
})
